// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__qyo6z","resendInfoText":"OnGoingPaymentBox_resendInfoText__2SiFe"};